<div class="administration-container container" fxFlexFill fxLayout="column" fxLayoutAlign="start center">
  <div class="page-container container" fxLayout="column">
    <mtn-administration-breadcrumbs></mtn-administration-breadcrumbs>
    <router-outlet></router-outlet>
  </div>
</div>
